import classes from '@/App.module.scss';
import RigWellTable from '@/components/RigWell/RigWell';
import { ContentSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton';

import { Suspense } from 'react';

export default function PageRigWell() {
  return (
    <div className={classes.reportsPage}>
      <div className={classes.reportTable}>
        <Suspense
          fallback={<ContentSkeleton />}
        >
          <RigWellTable />
        </Suspense>
      </div>
    </div>
  );
}
